import { render, staticRenderFns } from "./jxflzs.vue?vue&type=template&id=311b3304&"
import script from "./jxflzs.vue?vue&type=script&lang=js&"
export * from "./jxflzs.vue?vue&type=script&lang=js&"
import style0 from "./jxflzs.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports